import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { SIGN_IN } from "../auth/AuthActions";

export default function SignIn() {
  const [form, setForm] = useState({ email: "", password: "", rememberMe: false });
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    const val = type === 'checkbox' ? checked : value;
    setForm((prev) => ({ ...prev, [id]: val }));
    if (err) setErr("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) return setErr("Please fill in both fields.");
    try {
      setLoading(true);
      await SIGN_IN(form, form.rememberMe);
      navigate("/");
    } catch {
      setErr("Invalid credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container signup-custom">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-5">
          <div className="signin-card">
            <h1 className="mb-4 text-center">Sign In</h1>

            <form onSubmit={handleSubmit} noValidate>
              {/* Email */}
              <div className="mb-3">
                <label htmlFor="email" className="form-label">Email address</label>
                <input
                  id="email"
                  type="email"
                  className="form-control i7-input"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="you@example.com"
                  autoComplete="email"
                />
              </div>

              {/* Password with show/hide */}
              <div className="mb-2">
                <label htmlFor="password" className="form-label">Password</label>
                <div className="i7-input-wrap">
                  <input
                    id="password"
                    type={showPw ? "text" : "password"}
                    className="form-control i7-input"
                    value={form.password}
                    onChange={handleChange}
                    placeholder="••••••••"
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className="i7-toggle-btn"
                    onClick={() => setShowPw((s) => !s)}
                    aria-label={showPw ? "Hide password" : "Show password"}
                  >
                    {showPw ? "Hide" : "Show"}
                  </button>
                </div>
              </div>

              {/* Remember Me */}
              <div className="mb-3">
                <div className="form-check">
                  <input
                    id="rememberMe"
                    type="checkbox"
                    className="form-check-input"
                    checked={form.rememberMe}
                    onChange={handleChange}
                  />
                  <label htmlFor="rememberMe" className="form-check-label small text-muted">
                    Remember me (stay signed in)
                  </label>
                </div>
              </div>

              {err && <div className="alert alert-danger py-2">{err}</div>}

              <div className="d-flex justify-content-between align-items-center mb-3">
                <Link to="/accounts/password-reset" className="text-muted small">
                  Forgot password?
                </Link>
              </div>

              {/* Primary matches Welcome's teal button */}
              <button
                type="submit"
                className="btn i7-btn-teal w-100"
                disabled={loading}
              >
                <strong>{loading ? "Signing in..." : "Sign In"}</strong>
              </button>
            </form>

            <div className="mt-3 text-center small">
              Don’t have an account?{" "}
              <Link to="/accounts/register" className="i7-link-strong">Join, it’s free!</Link>
            </div>

            {/* If you want the secondary CTA as a button (like Welcome), show this: */}
            {/* <Link to="/accounts/register" className="btn i7-btn-deep w-100 mt-2">
              <strong>Join, it’s free!</strong>
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
}
